import type { SVGProps } from 'react'
const LineVideoCameraPlus = (props: SVGProps<SVGSVGElement>) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		width={24}
		height={24}
		fill="none"
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			d="M20.195 6.945c.39-.195.845-.175 1.215.055l-.005.005c.37.225.59.625.59 1.06v7.875c0 .435-.22.83-.59 1.06a1.23 1.23 0 0 1-1.215.055L18 15.96v1.29A2.755 2.755 0 0 1 15.25 20H4.75A2.755 2.755 0 0 1 2 17.25V6.75A2.755 2.755 0 0 1 4.75 4h10.505a2.755 2.755 0 0 1 2.75 2.75v1.29zM15.25 18.5c.69 0 1.25-.56 1.25-1.25V6.75c0-.69-.56-1.25-1.25-1.25H4.75c-.69 0-1.25.56-1.25 1.25v10.5c0 .69.56 1.25 1.25 1.25zM18 14.285l2.5 1.25V8.47L18 9.72zM9.25 8.5h1.5v2.75h2.75v1.5h-2.75v2.75h-1.5v-2.75H6.5v-1.5h2.75z"
			clipRule="evenodd"
		/>
	</svg>
)
export { LineVideoCameraPlus }
